import { Form } from "@minervaproject/fds";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { AlternateLink } from "../components/sso/alternate_link";
import { OrgInput } from "../components/sso/org_input";
import { OrgWrapper } from "../components/sso/org_wrapper";
import { SubmitButton } from "../components/sso/submit_button";
import { Title } from "../components/sso/title";
import { LoginStore } from "../store/login";
import { OrgAPI } from "src/api";
import { BrandingStore, OrgSamlIdpStore, OrgSettingsStore, OrgStore } from "src/store";

const OrgInputPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const loading = useSelector(OrgStore.selectors.selectLoading());

  const onSubmit = ({ setError }) => async ({ org }) => {
    if (
      org === "zu" &&
      window.waffle.flag_is_active("redirect_zu") &&
      window.context.uaeRedirectUrl
    ) {
      window.location.href = `${window.context.uaeRedirectUrl}/org/zu`;
      return;
    }

    dispatch(BrandingStore.actions.removeAll());
    dispatch(OrgSamlIdpStore.actions.removeAll());
    dispatch(OrgSettingsStore.actions.removeAll());
    dispatch(OrgStore.actions.removeAll());
    const { data } = await dispatch(OrgAPI.fetchOrgs({ orgIdentifier: org }));
    if (data.length) {
      history.push(`/org/${org}`);
    } else {
      setError("org", "manual", "That organization doesn’t exist. Please check your spelling.");
    }
  };

  const onForgotOrgClick = () => () => {
    dispatch(LoginStore.actions.clearError());
    dispatch(LoginStore.actions.update({ contextualMessage: null }));
    history.push("/forgot-org");
  };

  return (
    <OrgWrapper>
      <Title text="Sign In to Your Organization" />
      <Form onSubmit={onSubmit}>
        <OrgInput />
        <AlternateLink
          text="I don't know my organization"
          onClick={onForgotOrgClick}
          id="js-forgot-org"
        />
        <SubmitButton loading={loading} text="Next" />
      </Form>
    </OrgWrapper>
  );
};

export { OrgInputPage };
